import { useEffect, useState } from "react";
import "./DaysOfWork.css";
import { set } from "lodash";

type DaysOfWorkProps = {
    daysOfWork: string[];
    onChange: (days: string[]) => void;
}

export const DaysOfWork = ({ daysOfWork, onChange }: DaysOfWorkProps) => {

    const [newDays, setNewDays] = useState<Map<string, boolean>>(new Map());

    useEffect(() => {
        // const days = daysOfWork.split(",");

        const theDays: Map<string, boolean> = new Map();

        for (let day of daysOfWork) {
            theDays.set(day, true);
        }

        setNewDays(theDays);
    }, [daysOfWork]);

    const handleChange = (e: any) => {
        
        const theDays: Map<string, boolean> = new Map(newDays);
        theDays.set(e.target.name, e.target.checked);
        setNewDays(theDays);

        const days = Array.from(theDays.keys());
        onChange(days.filter(day => theDays.get(day)));
    }

    const dayMap = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

    return (
        <div className="days-of-work">
            {/* <div className="days-of-work-label">
                Days of Work
            </div> */}
            {dayMap.map((day, index) => {
                return (
                    <div key={day} className="days-of-work-day">
                        <span style={{width: "24px"}}> {day} </span>
                        <input
                            type="checkbox"
                            name={day}
                            checked={newDays.has(day) && newDays.get(day)}
                            onChange={handleChange}
                        />
                        {/* <label></label> */}
                    </div>
                );
            })}
        </div>
    );
}